// Bedienung wie eine App: Bildschirm bleibt an, solange eine Partie oder ein Rätsel läuft (Screen Wake
// Lock), und ein kurzer Vibrationsimpuls, wenn der Gegner gezogen hat (nur wo das Gerät es kann, Android).
import { loadPref, savePref } from './prefs';

type Lock = { released: boolean; release(): Promise<void> };
type Nav = Navigator & { wakeLock?: { request(type: 'screen'): Promise<Lock> } };

let vibrate: boolean = loadPref('vibrate', true);
let lock: Lock | null = null;
let wanted = false;

export const vibrateOn = () => vibrate;

export function setVibrate(on: boolean) {
  vibrate = on;
  savePref('vibrate', on);
}

export function buzz(pattern: number | number[] = 30) {
  if (vibrate && typeof navigator !== 'undefined' && 'vibrate' in navigator) navigator.vibrate(pattern);
}

/** Bei jedem Zeichnen aufrufen; holt die Sperre nur, wenn sie fehlt, und gibt sie frei, sobald sie nicht mehr gebraucht wird */
export async function keepAwake(on: boolean) {
  wanted = on;
  const nav = navigator as Nav;
  if (on && (!lock || lock.released) && nav.wakeLock) {
    lock = { released: false, release: async () => {} }; // Platzhalter gegen doppelte Anfragen
    try {
      lock = await nav.wakeLock.request('screen');
      if (!wanted) await lock.release();
    } catch {
      lock = null; // z. B. Akku-Sparmodus: dann eben nicht
    }
  } else if (!on && lock && !lock.released) {
    const l = lock;
    lock = null;
    await l.release();
  }
}
